const defaultError = 'Something went wrong! Try again later';

export const checkInternetError = 'Check your internet connection';

export const handleError = (error) => {
  const errorString = error?.response?.data?.message;
  return errorString ? errorString : defaultError;
};
